export default {"src":"/_next/static/image/public/images/flags/flag_230.de337e2a1686332dda1e78a1ef79fe04.svg","height":16,"width":24};